import React from "react";
import { connect } from "react-redux";
import { createSelector } from "reselect";
import { getPremium } from "../../../core/premium";
import { getAuth } from "../../../core/auth";
import { getUser } from "../../../core/user";
import Main from "../../components/main";
import Box from "../../components/box";
import Button from "../../components/button";
import P from "../../components/p";
import A from "../../components/a";
import "./styles.css";

const Download = ({ premium, auth, user }) => (
  <Main>
    <Box>
      <div className="download-box">
        {premium === "true" ? (
          <div className="download-flex">
            <div className="download-section">
              <div className="version-download">
                <p>Version: 0.0.15</p>
                <p>File Size: 37 MB</p>
                <Button href="https://firebasestorage.googleapis.com/v0/b/project-1029735015520686877.appspot.com/o/Ghast%20Setup%200.0.15.exe?alt=media&token=2e2acdd4-26b5-4ef9-9227-d8a5f24a42e5">
                  Download Now
                </Button>
              </div>
            </div>
            <div className="instructions-link">
              <h3>
                For instructions on how to install and run Ghast,{" "}
                <A className="link" href="/instructions">
                  click here.
                </A>
              </h3>
            </div>
          </div>
        ) : null}

        {premium !== "true" ? (
          <div>
            <P>You need to buy Ghast to download and run ghast!</P>
            <A href={"/#pricing"} className="link">
              Buy Ghast here
            </A>
          </div>
        ) : null}
      </div>
    </Box>
  </Main>
);

const mapStateToProps = createSelector(
  getPremium,
  getAuth,
  getUser,
  (premium, auth, user) => ({
    premium,
    auth,
    user,
  })
);

export default connect(mapStateToProps)(Download);



/** WEBPACK FOOTER **
 ** ./src/views/pages/download/index.js
 **/